import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchEscortForm } from "../../../store/slices/escortFormSlice";
import PrintWrapper, { printFooterStyles } from "../../common/PrintWrapper";
import logo from "../../../assets/images/logo-samplee.png";

export default function EscortFormPrint() {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { currentEscortForm, isLoading, error } = useSelector(
    (state) => state.escortForms
  );

  useEffect(() => {
    if (id) dispatch(fetchEscortForm(id));
  }, [dispatch, id]);

  useEffect(() => {
    if (currentEscortForm) {
      const t = setTimeout(() => window.print(), 800);
      window.onafterprint = () => navigate(-1);
      return () => {
        clearTimeout(t);
        window.onafterprint = null;
      };
    }
  }, [currentEscortForm, navigate]);

  if (isLoading) return <div className="p-4 text-center">Loading Escort Form print...</div>;
  if (error) return <div className="p-4 text-danger text-center">{error}</div>;
  if (!currentEscortForm) return null;

  const d = currentEscortForm;

  const fmt = (dateStr) =>
    dateStr
      ? new Date(dateStr).toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
      : "";

  const fmtDateTime = (dateTimeStr) => {
    if (!dateTimeStr) return "";
    const date = new Date(dateTimeStr);
    return date.toLocaleString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  return (
    <>
      <style jsx global>{`
        * {
          box-sizing: border-box !important;
          font-family: "Times New Roman", Times, serif !important;
        }

        body {
          background: #fff;
          color: #000;
          font-size: 11pt !important;
          line-height: 1.3 !important;
          margin: 0 !important;
          padding: 0 !important;
        }

        .print-container {
          padding: 10px !important;
          width: 100% !important;
          max-width: 800px;
          margin: 0 auto;
        }
        ${printFooterStyles}

        .header-logo {
          display: flex;
          justify-content: center;
          margin-bottom: 5px;
        }

        .header-logo img {
          height: 60px;
        }

        .header-text {
          text-align: center;
          margin-bottom: 20px;
        }

        .header-text h2 {
          font-size: 15pt !important;
          font-weight: bold !important;
          margin: 0 0 2px 0 !important;
          text-transform: uppercase;
        }

        .header-text h3 {
          font-size: 12pt !important;
          font-weight: bold !important;
          margin: 0 !important;
        }

        .info-table {
          width: 100%;
          border-collapse: collapse;
          margin-bottom: 15px;
        }

        .info-table td {
          padding: 5px 8px;
          font-size: 10pt;
          vertical-align: middle;
        }

        .label {
          font-weight: bold;
          width: 30%;
        }

        .value {
          border-bottom: 1px dotted #000;
          width: 70%;
        }

        .agreement-box {
          border: 1px solid #000;
          padding: 12px;
          margin-bottom: 15px;
          background-color: #fafafa;
        }

        .agreement-title {
          font-weight: bold;
          font-size: 11pt;
          margin-bottom: 10px;
          text-decoration: underline;
        }

        .agreement-item {
          display: flex;
          align-items: flex-start;
          margin-bottom: 8px;
          font-size: 10pt;
          line-height: 1.4;
        }

        .checkbox {
          width: 14px;
          height: 14px;
          border: 1.5px solid #000;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          margin-right: 8px;
          flex-shrink: 0;
          font-size: 9pt;
          font-weight: bold;
          margin-top: 2px;
        }

        .section-title {
          font-size: 11.5pt !important;
          font-weight: bold !important;
          margin-top: 15px !important;
          margin-bottom: 5px !important;
          border-bottom: 1px solid #000;
          padding-bottom: 2px;
        }

        .info-list {
          list-style: none !important;
          padding-left: 0 !important;
          margin-bottom: 10px !important;
        }

        .info-list li {
          margin-bottom: 6px !important;
          display: flex;
          align-items: flex-end;
        }

        .info-label {
          font-weight: bold;
          min-width: 180px;
          flex-shrink: 0;
        }

        .info-val-underline {
          border-bottom: 1px dotted #000;
          flex-grow: 1;
          padding-left: 5px;
          padding-bottom: 1px;
          font-weight: normal;
        }

        .paragraph-text {
          margin-bottom: 8px !important;
          text-align: justify;
        }

        .checkbox-container {
          margin: 8px 0 !important;
        }

        .checkbox-item {
          display: flex;
          align-items: flex-start;
          margin-bottom: 4px !important;
        }

        .checkbox-box {
          width: 14px;
          height: 14px;
          border: 1.5px solid #000;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          margin-right: 8px;
          flex-shrink: 0;
          font-size: 9pt;
          font-weight: bold;
          margin-top: 2px;
        }

        .bullet-list {
          padding-left: 20px !important;
          margin-bottom: 10px !important;
        }

        .bullet-list li {
          margin-bottom: 4px !important;
        }

        .signature-block {
          margin-top: 20px !important;
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 15px;
        }

        .signature-item {
          border: 1px solid #ddd;
          padding: 8px;
          border-radius: 4px;
          background-color: #fafafa;
        }

        .signature-item-title {
          font-weight: bold;
          text-decoration: underline;
          margin-bottom: 8px;
          font-size: 10pt;
        }

        .sig-row {
          display: flex;
          margin-bottom: 4px;
          align-items: flex-end;
        }

        .sig-label {
          font-weight: bold;
          font-size: 9.5pt;
          min-width: 80px;
        }

        .sig-line {
          border-bottom: 1px dotted #000;
          flex-grow: 1;
          font-size: 9.5pt;
          padding-left: 4px;
        }

        .witness-row {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 15px;
          margin-top: 10px;
        }
      `}</style>

      <PrintWrapper>
        <div className="print-container">
          <div className="header-logo"><img src={logo} alt="The Recovery House Logo" /></div>
          <div className="header-text">
            <h2>THE RECOVERY HOUSE (TRH)</h2>
            <h3>Involuntary Admission / Assisted Pick-Up Authorization Form</h3>
            <p>(In accordance with the Sindh Mental Health Act 2013 &amp; Sindh Healthcare Commission Regulations)</p>
          </div>

        {/* 1. Patient Details */}
        <div className="section-title">1. Patient Details</div>
        <ul className="info-list">
          <li>
            <span className="info-label">• Patient Name:</span>
            <span className="info-val-underline">{d.patient_name || ""}</span>
          </li>
          <li>
            <span className="info-label">• CNIC / B-Form No.:</span>
            <span className="info-val-underline">{d.cnic_bform || ""}</span>
          </li>
          <li>
            <span className="info-label">• Age / Gender:</span>
            <span className="info-val-underline">{d.age_gender || ""}</span>
          </li>
          <li>
            <span className="info-label">• Residential Address:</span>
            <span className="info-val-underline">{d.residential_address || ""}</span>
          </li>
          <li>
            <span className="info-label">• Date of Admission Request:</span>
            <span className="info-val-underline">{fmt(d.date_of_admission_request)}</span>
          </li>
        </ul>

        {/* 2. Applicant Details */}
        <div className="section-title">2. Applicant / Nearest Relative / Legal Guardian Details</div>
        <p className="paragraph-text">I, the undersigned:</p>
        <ul className="info-list" style={{ paddingLeft: "15px" }}>
          <li>
            <span className="info-label">• Name:</span>
            <span className="info-val-underline">{d.applicant_name || ""}</span>
          </li>
          <li>
            <span className="info-label">• CNIC No.:</span>
            <span className="info-val-underline">{d.applicant_cnic || ""}</span>
          </li>
          <li>
            <span className="info-label">• Relationship to Patient:</span>
            <span className="info-val-underline">{d.applicant_relationship || ""}</span>
          </li>
          <li>
            <span className="info-label">• Contact Number:</span>
            <span className="info-val-underline">{d.applicant_contact || ""}</span>
          </li>
          <li>
            <span className="info-label">• Address:</span>
            <span className="info-val-underline">{d.applicant_address || ""}</span>
          </li>
        </ul>
        <p className="paragraph-text" style={{ fontStyle: "italic", fontSize: "10pt" }}>
          Declare that I am the lawful nearest relative / legal guardian of the above-named patient and am authorized to request assessment and admission under applicable law.
        </p>

        {/* 3. Grounds for Involuntary Admission Request */}
        <div className="section-title">3. Grounds for Involuntary Admission Request</div>
        <p className="paragraph-text">I state that the above-named patient:</p>
        <div className="checkbox-container">
          <div className="checkbox-item">
            <span className="checkbox-box">{d.ground_mental_disorder ? "✓" : ""}</span>
            <span>Is suffering from a suspected or diagnosed mental disorder</span>
          </div>
          <div className="checkbox-item">
            <span className="checkbox-box">{d.ground_harm_self ? "✓" : ""}</span>
            <span>Poses a risk of harm to self</span>
          </div>
          <div className="checkbox-item">
            <span className="checkbox-box">{d.ground_harm_others ? "✓" : ""}</span>
            <span>Poses a risk of harm to others</span>
          </div>
          <div className="checkbox-item">
            <span className="checkbox-box">{d.ground_unable_care_self ? "✓" : ""}</span>
            <span>Is unable to care for self due to mental illness</span>
          </div>
          <div className="checkbox-item">
            <span className="checkbox-box">{d.ground_refuses_voluntary ? "✓" : ""}</span>
            <span>Refuses voluntary assessment or admission</span>
          </div>
        </div>
        <p className="paragraph-text" style={{ fontSize: "9.5pt", marginTop: "5px" }}>
          I understand that under the Sindh Mental Health Act 2013, involuntary admission is permissible only when:
        </p>
        <ul className="bullet-list" style={{ fontSize: "9.5pt" }}>
          <li>A qualified psychiatrist determines that the patient is suffering from a mental disorder; AND</li>
          <li>Admission is necessary for the patient’s health or safety, or for the protection of others; AND</li>
          <li>The patient is unwilling or lacks capacity to consent.</li>
        </ul>

        {/* 4. Authorization for Assisted Pick-Up */}
        <div className="section-title">4. Authorization for Assisted Pick-Up (If Required)</div>
        <p className="paragraph-text">
          I authorize The Recovery House (TRH) to arrange for assisted transport/pick-up of the patient, if clinically indicated, using trained personnel and in a manner that:
        </p>
        <ul className="bullet-list" style={{ fontSize: "9.5pt" }}>
          <li>Respects dignity and privacy</li>
          <li>Uses minimum necessary restraint (if absolutely required)</li>
          <li>Complies with human rights standards</li>
          <li>Adheres to Sindh Healthcare Commission regulations</li>
        </ul>
        <p className="paragraph-text" style={{ fontSize: "9.5pt", fontStyle: "italic" }}>
          I understand that law enforcement may only be involved where legally required or where safety concerns arise.
        </p>

        {/* 5. Psychiatric Evaluation & Treatment */}
        <div className="section-title">5. Psychiatric Evaluation & Treatment</div>
        <p className="paragraph-text" style={{ fontSize: "9.5pt" }}>I acknowledge and understand that:</p>
        <ol className="bullet-list" style={{ fontSize: "9.5pt", listStyleType: "decimal" }}>
          <li>The patient will undergo assessment by a licensed psychiatrist.</li>
          <li>Admission will only proceed upon written certification by a psychiatrist as required by law.</li>
          <li>Psychotropic medication or emergency treatment may be administered strictly on clinical grounds.</li>
          <li>Emergency treatment without consent may only be provided to prevent immediate harm, in accordance with the Sindh Mental Health Act 2013.</li>
          <li>The patient retains legal rights, including: right to dignity, information, confidentiality, review, and representation.</li>
        </ol>

        {/* 6. Duration & Review of Involuntary Admission */}
        <div className="section-title">6. Duration & Review of Involuntary Admission</div>
        <ul className="bullet-list" style={{ fontSize: "9.5pt" }}>
          <li>Involuntary admission is subject to statutory review periods.</li>
          <li>Continued detention requires periodic psychiatric reassessment.</li>
          <li>The patient or family may request review as per legal provisions.</li>
          <li>TRH may discharge the patient if clinical criteria are no longer met.</li>
        </ul>

        {/* 7. Indemnity & Declaration */}
        <div className="section-title">7. Indemnity & Declaration</div>
        <p className="paragraph-text" style={{ fontSize: "9.5pt" }}>
          I declare that the information provided by me is true and accurate to the best of my knowledge. I hereby request assessment and possible involuntary admission in accordance with applicable laws and regulations.
        </p>

        {/* 8. Signatures Block */}
        <div className="section-title">8. Signatures & Approvals</div>
        <div className="signature-block">

          {/* Applicant Signature */}
          <div className="signature-item">
            <div className="signature-item-title">Applicant / Relative / Guardian</div>
            <div className="sig-row">
              <span className="sig-label">Name:</span>
              <span className="sig-line">{d.signature_applicant_name || ""}</span>
            </div>
            <div className="sig-row" style={{ marginTop: "10px" }}>
              <span className="sig-label">Signature:</span>
              <span className="sig-line" style={{ height: "20px" }}></span>
            </div>
            <div className="sig-row">
              <span className="sig-label">Date:</span>
              <span className="sig-line">{fmt(d.signature_applicant_date)}</span>
            </div>
          </div>

          {/* Assessing Psychiatrist Certification */}
          <div className="signature-item">
            <div className="signature-item-title">Assessing Psychiatrist</div>
            <div className="sig-row">
              <span className="sig-label">Name:</span>
              <span className="sig-line">{d.psychiatrist_name || ""}</span>
            </div>
            <div className="sig-row">
              <span className="sig-label">PMDC No:</span>
              <span className="sig-line">{d.psychiatrist_pmdc || ""}</span>
            </div>
            <div className="sig-row" style={{ marginTop: "10px" }}>
              <span className="sig-label">Signature:</span>
              <span className="sig-line" style={{ height: "20px" }}></span>
            </div>
            <div className="sig-row">
              <span className="sig-label">Cert. Date:</span>
              <span className="sig-line">{fmtDateTime(d.psychiatrist_certified_at)}</span>
            </div>
          </div>

          {/* TRH Authorized Representative */}
          <div className="signature-item">
            <div className="signature-item-title">TRH Authorized Representative</div>
            <div className="sig-row">
              <span className="sig-label">Name:</span>
              <span className="sig-line">{d.trh_representative_name || ""}</span>
            </div>
            <div className="sig-row">
              <span className="sig-label">Designation:</span>
              <span className="sig-line">{d.trh_representative_designation || ""}</span>
            </div>
            <div className="sig-row" style={{ marginTop: "10px" }}>
              <span className="sig-label">Signature:</span>
              <span className="sig-line" style={{ height: "20px" }}></span>
            </div>
            <div className="sig-row">
              <span className="sig-label">Date:</span>
              <span className="sig-line">{fmt(d.trh_representative_date)}</span>
            </div>
          </div>

          {/* Witnesses */}
          <div className="signature-item">
            <div className="signature-item-title">Witnesses (Two Required)</div>
            <div className="sig-row">
              <span className="sig-label">1. Name:</span>
              <span className="sig-line">{d.witness1_name || ""}</span>
            </div>
            <div className="sig-row">
              <span className="sig-label">Signature:</span>
              <span className="sig-line" style={{ borderBottomStyle: "solid" }}>
                {d.witness1_signature ? "Certified" : ""}
              </span>
            </div>
            <div className="sig-row" style={{ marginTop: "8px" }}>
              <span className="sig-label">2. Name:</span>
              <span className="sig-line">{d.witness2_name || ""}</span>
            </div>
            <div className="sig-row">
              <span className="sig-label">Signature:</span>
              <span className="sig-line" style={{ borderBottomStyle: "solid" }}>
                {d.witness2_signature ? "Certified" : ""}
              </span>
            </div>
          </div>

        </div>

      </div>
      </PrintWrapper>
    </>
  );
}
